import React from 'react';
import { illustrationPaths } from './IllustrationPaths';
export var Illustration = function Illustration(_ref) {
  var className = _ref.className,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabelProp = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
      _ref$ariaHidden = _ref.ariaHidden,
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      illustration = _ref.illustration,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      _ref$dataTest = _ref.dataTest,
      dataTest = _ref$dataTest === void 0 ? 'illustration' : _ref$dataTest;
  var fallbackIllustration = illustrationPaths.information;
  var path = illustrationPaths[illustration] == null ? fallbackIllustration.path : illustrationPaths[illustration].path;
  var viewBox = (illustrationPaths[illustration] == null ? fallbackIllustration.viewBox : illustrationPaths[illustration].viewBox) || '0 0 32 32';
  var ariaLabel = illustrationPaths[illustration] == null ? fallbackIllustration.ariaLabel : illustrationPaths[illustration].ariaLabel;
  return React.createElement("svg", {
    className: className,
    viewBox: viewBox,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabelProp || ariaLabel,
    width: width,
    height: height,
    "data-test": dataTest
  }, path);
};